import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ApiCalls } from '../api/api';
import { ReportPeriodDto } from '../api/generated/data-contracts';
import { CURRENT_PERIOD } from '../constants/queryKeys';
import { TimeInformation } from '../types/TimeInformation';

export interface ICopyTimesheetProps {
    reportPeriodId: string;
    setInformationDialogInformation: (value: React.SetStateAction<TimeInformation>) => void;
    setShowInformationDialog: (value: React.SetStateAction<boolean>) => void;
}

export const useCopyTimesheetWeek = () => {
    const queryClient = useQueryClient();
    const { t } = useTranslation('timesheet');

    const { mutate: mutateCopyTimesheet } = useMutation(
        (copyProps: ICopyTimesheetProps) =>
            ApiCalls.copyTimeEntriesFromPreviousUserPeriod({ toReportingPeriodId: copyProps.reportPeriodId }).then(res => res.data),
        {
            onSuccess: (data, props) => {
                if (data === null) {
                    const noPeriodTitle = t('dialog.information.noperiod.header');
                    const noPeriodDescription = t('dialog.information.noperiod.description');
                    props.setInformationDialogInformation({ header: noPeriodTitle, description: noPeriodDescription });
                    props.setShowInformationDialog(true);
                    return;
                }

                if (data.reportPeriod === null) {
                    const notEmptyTitle = t('dialog.information.notempty.header');
                    const notEmptyDescription = t('dialog.information.notempty.description');
                    props.setInformationDialogInformation({
                        header: notEmptyTitle,
                        description: notEmptyDescription,
                    });
                    props.setShowInformationDialog(true);
                    return;
                }

                const startDate = new Date(data.reportPeriod.startDate);

                queryClient.setQueryData<ReportPeriodDto>([CURRENT_PERIOD, startDate.getISOStringMidnight()], (prevState: ReportPeriodDto) => {
                    return {
                        ...prevState,
                        timesheetData: {
                            ...data.timesheetData,
                            rows: [...data.timesheetData.rows],
                            allocations: [...data.timesheetData.allocations],
                        },
                    };
                });
            },
        },
    );

    return { mutateCopyTimesheet };
};
